// @flow
import React, {type Node, useEffect, useState} from 'react'
import queryString from 'query-string'
import AppRouter, {type ReactRouterContext} from 'utils/AppRouter'

import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import Search from 'components/ui/icons/Search'
import IconButton from 'components/SideBar/ui/IconButton'
import QueryInput from './QueryInput'
import styles from './index.scss'
import type {
  FullSearch_viewer as Viewer,
} from './__generated__/FullSearch_viewer.graphql'

type Props = $ReadOnly<{
  autofocus: boolean,
  viewer: Viewer,
}> & ReactRouterContext

const searchString = (location) => (
  location.pathname === '/search'
    ? queryString.parse(location.search).search || ''
    : ''
)

function FullSearch({autofocus, viewer, history, location}: Props): Node {
  const [search, setSearch] = useState(searchString(location))

  useEffect(() => {
    history.listen((currentLocation) => {
      setSearch(searchString(currentLocation))
    })
  }, [history, setSearch])

  const orgnavScopedSearchPath = AppRouter.instance.getOrgnavScopedPath(
    viewer.routes.searchPath,
  )

  const updateSearch = (e: SyntheticInputEvent<HTMLInputElement>) => {
    setSearch(e.target.value)
  }

  const doSearchWithinSpa = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()
    history.push({
      pathname: orgnavScopedSearchPath,
      search: queryString.stringify({search}),
    })
  }

  return (
    <form
      action={viewer.routes.searchPath}
      onSubmit={doSearchWithinSpa}
    >
      <div className={styles.sideBar}>
        <QueryInput
          autofocus={autofocus}
          value={search}
          onChange={updateSearch}
        />
        <IconButton
          size="md"
          submit
          onClick={doSearchWithinSpa}
          alt={I18n.t('nav.search')}
          theme="darkBlue"
        >
          <Search />
        </IconButton>
      </div>
    </form>
  )
}

export default (createFragmentContainer(FullSearch, {
  viewer: graphql`
    fragment FullSearch_viewer on Person {
      routes {
        searchPath
      }
    }
  `,
}): RelayFragmentContainer<typeof(FullSearch)>)
